<template>
  <div>
    <!-- Example of logo, must change in future-->
    <img :src="require(`@/../public/${asset}/logo.png`)" :style="imageStyle" />
  </div>
</template>

<script>
export default {
  name: "Logo",
  props: {
    name: String,
    logged: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      asset: process.env.VUE_APP_PUBLIC_ASSETS,
    };
  },
  computed: {
    imageStyle() {
      let style = {};
      return style;
    }
  }
};
</script>

<style lang="css" scoped>
div {
  display: flex;
  padding: 30px 5px;
  width: 100%;
  align-items: center;
}
img {
  margin: auto;
  max-width: 50%;
}
</style>